<template>
    <div
        v-if="name"
        class="modal-opener"
        :class="extraClass"
        @click="showModal"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
        },
        data:{
            type: [Number, String, Array, Object],
            required: false,
        }, 
        extraClass:{
            type: String,
            required: false,
        }       
    },
    methods:{
        showModal(){

            window.events.$emit('showModal', {
                name: this.name,
                data: this.data
            })
        }
    }
}
</script>

<style>

</style>